import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PartnershipSection from './components/PartnershipSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#1a2332]">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <PartnershipSection />
      <CTASection />
      <Footer />
    </div>
  );
}
